/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react'
import MainLayout from '../Layouts/Mainlayout'
import { useParams } from 'react-router-dom'
import { useLocation } from "react-router";
import AppConfigDetailsPage from './AppConfigDetailsPage';


const EditAppConfig: React.FC = () => {

  const param = useParams();
  // const data: any = useLocation();
  // const {configType} = param;
  return (
    <div className="flex flex-row justify-start">
      <MainLayout>
        <AppConfigDetailsPage/>
      </MainLayout>
    </div>
  )
}

export default EditAppConfig